export default __webpack_public_path__ + "static/media/599.c3661293.jpg";